import { Api } from '../api';

/**
 * The agency team, in a stable order for listing in pickers.
 */
export function getAgencySorted(
  users: ReadonlyArray<Api.User.BaseView>
): Array<Api.User.BaseView> {
  return users
    .filter((user) => user.agencyRole !== null)
    .sort((a, b) => getFullName(a).localeCompare(getFullName(b)));
}

/**
 * The daily tasks dashboard for an agency user.
 */
export function getDailyTasksPath(userId: string): string {
  return `/dashboard/tasks/${userId}`;
}

/**
 * Where an agency user lands by default. Null for clients, who have no agency
 * dashboard.
 */
export function getDashboardPath(user: Api.User.BaseView): string | null {
  return user.agencyRole ? getDailyTasksPath(user.id) : null;
}

export function getFullName(user: Api.User.BaseView): string {
  return `${user.firstName} ${user.lastName}`;
}
